<script setup lang="ts">
definePageMeta({
    sidebar: false,
    hidePromotions: true,
})

const { site } = useCoreConfig()

const { data: generalTerms } = await useGeneralConsentData()

// SEO - START
const { getHead, getSeoMeta } = useStrapiSeo(
    {
        metaTitle: `Vilkår | ${site.name}`,
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div class="betingelser">
        <div class="content">
            <NimbusGeneralTerms
                v-if="generalTerms"
                :content="generalTerms"
                use-route-hashes
            />
            <p v-else>
                <span>Der skete en fejl ved hentning af betingelserne. Prøv venligst igen om et øjeblik.</span>
            </p>
        </div>
    </div>
</template>
